/* ==========================================================================
   Buy 2 Get 2: sell singles only, for the duration of the sale.

   The multi-packs carry their own bulk discount -- a Pack of 4 is cheaper than
   four singles -- and during the sale that discount would stack on top of the
   offer, handing away more margin than intended. Rewriting 63 variant prices
   twice a month would fix it and is a lot of moving parts around live money, so
   the packs are simply taken off the page instead. The customer pays the same
   per packet either way: two singles under the offer is the same rate as two
   normalised Pack of 2s.

   Notes for whoever touches this next:

   - The picker is rendered by an app (React, styled-components), so its class
     names carry a build hash -- `newStyles__VariantButton-sc-4gyd4u-4` -- that
     changes whenever that app ships. Nothing here may depend on those. The
     stable hooks are `li.pk_item`, `data-option1` (a handle: `pack-of-2`) and
     `Act_variant` for the current selection.

   - A product whose ONLY option is a multi-pack is left completely alone.
     Hiding its single option would leave a product nobody can buy. That is why
     this keys off finding a `pack-of-1` sibling rather than off the setting.

   - The app re-renders on its own, so the work is idempotent and repeated on
     mutation rather than done once at load.
   ========================================================================== */
(function () {
  'use strict';

  /* Two different pack pickers exist on a product page and BOTH have to be
     handled. The first is app-rendered (React) and keys off `data-option1`; the
     second is the theme's own "Pick Your Pack" cards, which key off
     `data-value`. Missing the second one left the packs on screen, still
     advertising "Pack of 4 - 55% OFF", under a picker that no longer offered
     them. */
  var SOURCES = [
    { sel: 'li.pk_item[data-option1^="pack-of-"]', attr: 'data-option1' },
    { sel: 'li.swatch_pr_item[data-value^="pack-of-"]', attr: 'data-value' }
  ];
  var SELECTED = /(^|\s)(Act_variant|selected|is-selected|active)(\s|$)/;
  var SINGLE = 'pack-of-1';
  var HIDDEN = 'data-b2g2-hidden';
  var clicks = 0;          // re-selecting fires the app's own handlers, which
  var MAX_CLICKS = 12;     // re-render, which brings us back here. Bound it.

  function active() {
    var el = document.getElementById('hn-cart-settings');
    if (!el) return false;
    try {
      var s = JSON.parse(el.textContent);
      return !!(s.b2g2 && s.b2g2.active);
    } catch (e) { return false; }
  }

  function apply() {
    // One picker can appear more than once on a page (quick-shop, featured
    // product, related products), so options are grouped by the list they
    // belong to and each list is decided on its own.
    var groups = [];
    SOURCES.forEach(function (src) {
      Array.prototype.slice.call(document.querySelectorAll(src.sel)).forEach(function (li) {
        var host = li.parentElement;
        var g = null;
        groups.forEach(function (candidate) { if (candidate.host === host) g = candidate; });
        if (!g) { g = { host: host, attr: src.attr, items: [] }; groups.push(g); }
        g.items.push(li);
      });
    });
    if (!groups.length) return;

    groups.forEach(function (g) {
      var single = null;
      g.items.forEach(function (li) {
        if (li.getAttribute(g.attr) === SINGLE) single = li;
      });
      // No single to fall back to: this product is sold only in packs and is
      // none of our business.
      if (!single || g.items.length < 2) return;

      var hidTheSelection = false;
      g.items.forEach(function (li) {
        if (li === single) {
          li.removeAttribute(HIDDEN);
          return;
        }
        if (!li.hasAttribute(HIDDEN)) li.setAttribute(HIDDEN, '1');
        if (SELECTED.test(li.className || '')) hidTheSelection = true;
      });

      /* The shopper may have arrived on a pack -- a ?variant= link, an ad, a
         back button. Leaving it selected would show a picker with nothing
         highlighted and add a pack to the cart anyway, so hand the selection
         back to the single through the app's own click handler rather than by
         writing to the form ourselves. */
      if (hidTheSelection && clicks < MAX_CLICKS) {
        clicks++;
        single.click();
      }
    });
  }

  function start() {
    if (!active()) return;
    apply();

    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () { pending = null; apply(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
